import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getAppInfo = async (tenantid: string, appid: string) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/app-info?tenantid=${tenantid}&appid=${appid}`
  );

  return data;
};
